import { ReducersTypes } from "constants/ReducersTypes";
import { getUXSettingsFromStorage } from "utils";
import moment from "moment";
import omit from "lodash/omit";

const savedFilters = getUXSettingsFromStorage("ANALYTICS_BANK_BALANCE_FILTERS");

export const initialBankBalanceFilters = {
  sort_by: "bank_account_name",
  sort_order: "asc",
  bankAccountSelect: null,
  corporate_entity_id: [],
  interval: "",
  from_date: moment().format("MM/DD/YYYY"),
  to_date: moment().format("MM/DD/YYYY"),
};

const normalizeFilterDate = (date, fallback) => {
  const parsedDate = moment(date, ["MM/DD/YYYY", moment.ISO_8601], true);

  return parsedDate.isValid() ? parsedDate.format("MM/DD/YYYY") : fallback;
};

const reducerInitialFilter = {
  ...initialBankBalanceFilters,
  ...savedFilters,
  from_date: normalizeFilterDate(
    savedFilters?.from_date,
    initialBankBalanceFilters.from_date
  ),
  to_date: normalizeFilterDate(
    savedFilters?.to_date,
    initialBankBalanceFilters.to_date
  ),
};

export const initialData = {
  listData: [],
  isFetching: false,
  filters: reducerInitialFilter,
  total: 0,
};

const bankBalanceReportDetails = (state = initialData, { type, payload }) => {
  switch (type) {
    case ReducersTypes.BANK_BALANCE_REPORT_LIST_FETCHING:
      return {
        ...state,
        isFetching: true,
      };

    case ReducersTypes.BANK_BALANCE_REPORT_LIST_RESET:
      return {
        ...initialData,
        filters: {
          ...reducerInitialFilter,
          ...payload?.data,
        },
      };

    case ReducersTypes.BANK_BALANCE_REPORT_LIST_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
      };

    case ReducersTypes.BANK_BALANCE_REPORT_LIST:
      return {
        ...state,
        isFetching: false,
        listData: payload.data.result || [],
        filters: {
          ...omit(state.filters, ["is_export"]),
          ...omit(payload.data.filters || {}, ["is_export"]),
        },
        ...(payload.data.filters?.is_export
          ? {}
          : { total: payload.data.total || 0 }),
      };

    default:
      return state;
  }
};

export default bankBalanceReportDetails;
